import { Sparkles } from "lucide-react";
import { cn } from "utils";
import {
  SCORE_COLORS,
  SCORE_COLOR_ZERO_CARD_VIEW,
} from "constants/scoreColors";

const BadgeScore = ({ ideal, score }) => {
  const text = ideal ? "Ideal Candidate" : `Match Score: ${score}/5`;

  const getScoreColor = (ideal, score) => {
    if (ideal) {
      return SCORE_COLORS.ideal;
    }

    if (score === 0) {
      return SCORE_COLOR_ZERO_CARD_VIEW;
    }

    return SCORE_COLORS[score] ?? "#cfd4d8";
  };

  const scoreBGColor = getScoreColor(ideal, score);

  if (score === undefined) {
    return null;
  }

  return (
    <div
      className={cn(
        "flex items-center gap-2 absolute top-0 left-8 rounded-b-md font-medium text-white",
        { "text-sm px-3 py-1": !ideal, "text-base px-2.5": ideal }
      )}
      style={{ backgroundColor: scoreBGColor }}
    >
      {ideal ? (
        <Sparkles size={16} className="fill-[#F8CA42]" color="#F8CA42" />
      ) : (
        <></>
      )}
      <p>{text}</p>
    </div>
  );
};

export default BadgeScore;
